import React, {Component} from 'react';
import {withTranslation, Trans} from 'react-i18next';

class SearchFilter extends Component {
  render() {
    const input_placeholder = this.props.t('search_filter.filter_input_placeholder', 'Search for...');
    const input_title = this.props.t('search_filter.filter_input_title', 'Enter the terms you wish to search for.');
    const label_search = this.props.t('search_filter.filter_label_search', 'Search');
    const label_submit = this.props.t('search_filter.filter_label_submit', 'Search');

    return (
      <div className="search-form search-filter">
        <label htmlFor="search-filter" className="mr-m fs-l search-filter__label"><Trans i18nKey="search_filter.filter_label_search">Search</Trans></label>
        <input onChange={(event) => this.props.onFilter({
          name: 'field_search',
          value: event.target.value,
          label: label_search
        })} title={input_title} placeholder={input_placeholder} type="search" name="field_search" size="15" maxLength="128"/>
        <div className="form-actions">
          <input className="search-form__submit button" type="submit" value={label_submit}/>
        </div>
      </div>
    );
  }
}

export default withTranslation()(SearchFilter);

